import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FunctionsService } from '../../___LOGIC/__common/functions.service';
import { ResolverService } from '../../___LOGIC/__common/resolver.service';
import { ClientBoardResolver } from 'src/app/___LOGIC/resolvers/client-board.resolver';

@Component({
  selector: 'app-client-board',
  templateUrl: './client-board.component.html',
  styleUrls: ['./client-board.component.css']
})
export class ClientBoardComponent implements OnInit {

  loading = false;
  clientCards = [];
  
  constructor(private resolver: ResolverService,private commonFunctions: FunctionsService,private router: Router,private route: ActivatedRoute,private clientBoardResolver: ClientBoardResolver) { }

  ngOnInit(): void {
    const data = this.route.snapshot.data['clientBoard'];
    this.clientCards = data.clientBoardData.items;
  }

  getClientCards(){
   return this.clientCards;
  }

  reloadDashboardData(){
    debugger
  }

  saveClientDashboardInfo(data){
    this.loading = false;
    this.clientCards = data.records;
  }

  getClientList(){
    if(this.resolver.getDependency('getClientList') && this.resolver.getDependency('getClientList')['records']){
      return this.resolver.getDependency('getClientList')['records'];
    }else{
      return [];
    }
  }

  goToProfile(event){
    this.resolver.setCurrentClientCard(event.selected);
    this.commonFunctions.setSelectedClientId(event.selected.id);
    this.resolver.getClientDetails(true);
    this.router.navigateByUrl('profile/edit/'+event.selected.id);
  }

  showClientList(){
    this.router.navigateByUrl('client-manager');
  }

}
